
import { CFCDN } from "../../shop-front-component/ProductCollection";



export interface colourType {
    title: string;
    src: string;
}


export const VibeBlockout = [
    {
        title:'Alloy',
        src: CFCDN+"vibe-block-out/Alloy.jpg",
    },
    {
        title:'Birch',
        src: CFCDN+"vibe-block-out/Birch.jpg",
    },
    {
        title:'Bistro',
        src: CFCDN+"vibe-block-out/Bistro.jpg",
    },
    {
        title:'Brulee Metallic',
        src: CFCDN+"vibe-block-out/Brulee-Metallic.jpg",
    },
    {
        title:'Chateau',
        src: CFCDN+"vibe-block-out/Chateau.jpg",
    },
    {
        title:'Clay',
        src: CFCDN+"vibe-block-out/Clay.jpg",
    },
    {
        title:'Cloud',
        src: CFCDN+"vibe-block-out/Cloud.jpg",
    },
    {
        title:'Coal',
        src: CFCDN+"vibe-block-out/Coal.jpg",
    },
    {
        title:'Dune',
        src: CFCDN+"vibe-block-out/Dune.jpg",
    },
    {
        title:'Ice',
        src: CFCDN+"vibe-block-out/Ice.jpg",
    },
    {
        title:'Lace',
        src: CFCDN+"vibe-block-out/Lace.jpg",
    },
    {
        title:'Limestone',
        src: CFCDN+"vibe-block-out/Limestone.jpg",
    },
    {
        title:'Linen',
        src: CFCDN+"vibe-block-out/Linen.jpg",
    },
    {
        title:'Loft',
        src: CFCDN+"vibe-block-out/Loft.jpg",
    },
    {
        title:'Mercury Metallic',
        src: CFCDN+"vibe-block-out/Mercury Metallic.jpg",
    },
    {
        title:'Mist',
        src: CFCDN+"vibe-block-out/Mist.jpg",
    },
    {
        title:'Moon',
        src: CFCDN+"vibe-block-out/Moon.jpg",
    },
    {
        title:'Nimbus',
        src: CFCDN+"vibe-block-out/Nimbus.jpg",
    },
    {
        title:'Odessey',
        src: CFCDN+"vibe-block-out/Odessey.jpg",
    },
    {
        title:'Orient',
        src: CFCDN+"vibe-block-out/Orient.jpg",
    },
    {
        title:'Porcelain',
        src: CFCDN+"vibe-block-out/Porcelain.jpg",
    },
    {
        title:'Pure',
        src: CFCDN+"vibe-block-out/Pure.jpg",
    },
    {
        title:'Spirit',
        src: CFCDN+"vibe-block-out/Spirit.jpg",
    },
    {
        title:'Stone',
        src: CFCDN+"vibe-block-out/Stone.jpg",
    },
    {
        title:'Storm',
        src: CFCDN+"vibe-block-out/Storm.jpg",
    },
    {
        title:'Surf',
        src: CFCDN+"vibe-block-out/Surf.jpg",
    },
    {
        title:'Terrace',
        src: CFCDN+"vibe-block-out/Terrace.jpg",
    },
    {
        title:'Umber',
        src: CFCDN+"vibe-block-out/Umber.jpg",
    },
    {
        title:'Tundra',
        src: CFCDN+"vibe-block-out/Tundra.jpg",
    },
    {
        title:'Whisper',
        src: CFCDN+"vibe-block-out/Whisper.jpg",
    },
]

// Blockout Fabrics
const ChatswoodBlockout = [{title: "Aztec", src: CFCDN+"Chatswood-Block-Out/Aztec.jpg"}, {title: "Beluga", src: CFCDN+"Chatswood-Block-Out/Beluga.jpg"}, {title: "Cinnamon", src: CFCDN+"Chatswood-Block-Out/Cinnamon.jpg"}, {title: "Cyrstal", src: CFCDN+"Chatswood-Block-Out/Cyrstal.jpg"}, {title: "Fawn", src: CFCDN+"Chatswood-Block-Out/Fawn.jpg"}, {title: "Ganache", src: CFCDN+"Chatswood-Block-Out/Ganache.jpg"}, {title: "Gemstone", src: CFCDN+"Chatswood-Block-Out/Gemstone.jpg"}, {title: "Lunar", src: CFCDN+"Chatswood-Block-Out/Lunar.jpg"}, {title: "Portabello", src: CFCDN+"Chatswood-Block-Out/Portabello.jpg"}, {title: "Rice", src: CFCDN+"Chatswood-Block-Out/Rice.jpg"}, {title: "Royale", src:CFCDN+ "Chatswood-Block-Out/Royale.jpg"}, {title: "Shimmer", src: CFCDN+"Chatswood-Block-Out/Shimmer.jpg"}]
const DouBlockOut = [{title: "Aztec", src: CFCDN +"Duo-Block-Out/Aztec.jpg"}, {title: "Basalt", src: CFCDN +"Duo-Block-Out/Basalt.jpg"}, {title: "Dove", src: CFCDN +"Duo-Block-Out/Dove.jpg"}, {title: "Iron", src: CFCDN +"Duo-Block-Out/Iron.jpg"}, {title: "Nova", src: CFCDN +"Duo-Block-Out/Nova.jpg"}, {title: "Salt", src: CFCDN +"Duo-Block-Out/Salt.jpg"}, {title: "Stalla", src: CFCDN +"Duo-Block-Out/Stalla.jpg"}, {title: "Tempo", src: CFCDN +"Duo-Block-Out/Tempo.jpg"}]
const KamarBlockOut = [{title: "Cliff", src: CFCDN + "kamar-block-out/Cliff.jpg"}, {title: "Dew", src: CFCDN + "kamar-block-out/Dew.jpg"}, {title: "Frost", src: CFCDN + "kamar-block-out/Frost.jpg"}, {title: "Glade", src: CFCDN + "kamar-block-out/Glade.jpg"}, {title: "Haze", src: CFCDN + "kamar-block-out/Haze.jpg"}, {title: "Magma", src: CFCDN + "kamar-block-out/Magma.jpg"}, {title: "Moonscape", src: CFCDN + "kamar-block-out/Moonscape.jpg"}, {title: "Ocean", src: CFCDN + "kamar-block-out/Ocean.jpg"}, {title: "Petrol", src: CFCDN + "kamar-block-out/Petrol.jpg"}, {title: "Rock", src: CFCDN + "kamar-block-out/Rock.jpg"}, {title: "Sandstone", src: CFCDN + "kamar-block-out/Sandstone.jpg"}, {title: "Shell", src: CFCDN + "kamar-block-out/Shell.jpg"}]
const LereveBlockOut = [{title: "Chalk", src: CFCDN + "Lereve-Block-Out/Chalk.jpg"}, {title: "Concrete", src: CFCDN + "Lereve-Block-Out/Concrete.jpg"}, {title: "Crystal", src: CFCDN + "Lereve-Block-Out/Crystal.jpg"}, {title: "Graphite", src: CFCDN + "Lereve-Block-Out/Graphite.jpg"}, {title: "Marble", src: CFCDN + "Lereve-Block-Out/Marble.jpg"}, {title: "Mink", src: CFCDN + "Lereve-Block-Out/Mink.jpg"}, {title: "Onyx", src: CFCDN + "Lereve-Block-Out/Onyx.jpg"}, {title: "Pewter", src: CFCDN + "Lereve-Block-Out/Pewter.jpg"}, {title: "Sand", src: CFCDN + "Lereve-Block-Out/Sand.jpg"}, {title: "Shell", src: CFCDN + "Lereve-Block-Out/Shell.jpg"}]
const linesqueBlockout = [{title: "Almond",  src: CFCDN + "linesque-black-out/Almond.jpg"}, {title: "Aspen",  src: CFCDN + "linesque-black-out/Aspen.jpg"}, {title: "Blanco",  src: CFCDN + "linesque-black-out/Blanco.jpg"}, {title: "Breeze",  src: CFCDN + "linesque-black-out/Breeze.jpg"}, {title: "Denim",  src: CFCDN + "linesque-black-out/Denim.jpg"}, {title: "Dove",  src: CFCDN + "linesque-black-out/Dove.jpg"}, {title: "Fig",  src: CFCDN + "linesque-black-out/Fig.jpg"}, {title: "Fleece",  src: CFCDN + "linesque-black-out/Fleece.jpg"}, {title: "Fossil",  src: CFCDN + "linesque-black-out/Fossil.jpg"}, {title: "Raffia",  src: CFCDN + "linesque-black-out/Raffia.jpg"}, {title: "Soba",  src: CFCDN + "linesque-black-out/Soba.jpg"}, {title: "Vine",  src: CFCDN + "linesque-black-out/Vine.jpg"}]
const mantraBlockOut = [{ title: "Cotton",  src: CFCDN + "mantra-block-out/Cotton.jpg"}, { title: "Flint",  src: CFCDN + "mantra-block-out/Flint.jpg"}, { title: "Opal",  src: CFCDN + "mantra-block-out/Opal.jpg"}, { title: "Parchment",  src: CFCDN + "mantra-block-out/Parchment.jpg"}, { title: "Pebble",  src: CFCDN + "mantra-block-out/Pebble.jpg"}, { title: "Seagrass",  src: CFCDN + "mantra-block-out/Seagrass.jpg"}, { title: "Seed Pearl",  src: CFCDN + "mantra-block-out/Seed Pearl.jpg"}, { title: "Sesame",  src: CFCDN + "mantra-block-out/Sesame.jpg"}, { title: "Shale",  src: CFCDN + "mantra-block-out/Shale.jpg"}, { title: "Spice",  src: CFCDN + "mantra-block-out/Spice.jpg"}]
const palmBeachBlockout = [{ title: "Dusk", src: CFCDN + "Palm-Beach-Block-Out/Dusk.jpg"}, { title: "Gull", src: CFCDN + "Palm-Beach-Block-Out/Gull.jpg"}, { title: "Iron", src: CFCDN + "Palm-Beach-Block-Out/Iron.jpg"}, { title: "Jasmine", src: CFCDN + "Palm-Beach-Block-Out/Jasmine.jpg"}, { title: "Lyric", src: CFCDN + "Palm-Beach-Block-Out/Lyric.jpg"}, { title: "Merino", src: CFCDN + "Palm-Beach-Block-Out/Merino.jpg"}, { title: "Porpoise", src: CFCDN + "Palm-Beach-Block-Out/Porpoise.jpg"}, { title: "Quatz", src: CFCDN + "Palm-Beach-Block-Out/Quatz.jpg"}, { title: "Quill", src: CFCDN + "Palm-Beach-Block-Out/Quill.jpg"}, { title: "Summer Storm", src: CFCDN + "Palm-Beach-Block-Out/Summer Storm.jpg"}, { title: "Thunder", src: CFCDN + "Palm-Beach-Block-Out/Thunder.jpg"}, { title: "Urban", src: CFCDN + "Palm-Beach-Block-Out/Urban.jpg"}]
const skyBlockout = [{title: "Blazer", src: CFCDN + "Skye-Block-Out/Blazer.jpg"}, {title: "Chiffon", src: CFCDN + "Skye-Block-Out/Chiffon.jpg"}, {title: "Chrome", src: CFCDN + "Skye-Block-Out/Chrome.jpg"}, {title: "Earl Grey", src: CFCDN + "Skye-Block-Out/Earl_Grey.jpg"}, {title: "Oyster", src: CFCDN + "Skye-Block-Out/Oyster.jpg"}, {title: "Porcelain", src: CFCDN + "Skye-Block-Out/Porcelain.jpg"}, {title: "Raven", src: CFCDN + "Skye-Block-Out/Raven.jpg"}, {title: "Sail", src: CFCDN + "Skye-Block-Out/Sail.jpg"}, {title: "Swan", src: CFCDN + "Skye-Block-Out/Swan.jpg"}]
const dawnBO = [{title: "Beige", src: CFCDN + "Dawn/Beige.jpg"}, {title: "Bison", src: CFCDN + "Dawn/Bison.jpg"}, {title: "Caviar", src: CFCDN + "Dawn/Caviar.jpg"}, {title: "Custom Cream", src: CFCDN + "Dawn/Custom Cream.jpg"}, {title: "Earthen", src: CFCDN + "Dawn/Earthen.jpg"}, {title: "Ivory", src: CFCDN + "Dawn/Ivory.jpg"}, {title: "Macchiato", src: CFCDN + "Dawn/Machiato.jpg"}, {title: "Mid Grey", src: CFCDN + "Dawn/Mid Grey.jpg"}, {title: "Natural", src: CFCDN + "Dawn/Natural.jpg"}, {title: "Nutmeg", src: CFCDN + "Dawn/Nutmeg.jpg"}, {title: "Pewter", src: CFCDN + "Dawn/Pewter.jpg"}, {title: "Royal Blue", src: CFCDN + "Dawn/Royal Blue.jpg"}, {title: "Sesame", src: CFCDN + "Dawn/Sesame.jpg"}, {title: "Shale", src: CFCDN + "Dawn/Shale.jpg"}, {title: "Taupe", src: CFCDN + "Dawn/Taupe.jpg"}]
const sunsetBO = [{title: "Antique", src: CFCDN + "Sunset/Antique.jpg"}, {title: "Ash Grey", src: CFCDN + "Sunset/Ash Grey.jpg"}, {title: "Bark", src: CFCDN + "Sunset/Bark.jpg"}, {title: "Beaver", src: CFCDN + "Sunset/Beaver.jpg"}, {title: "Bone", src: CFCDN + "Sunset/Bone.jpg"}, {title: "Cashew", src: CFCDN + "Sunset/Cashew.jpg"}, {title: "Ecru", src: CFCDN + "Sunset/Ecru.jpg"}, {title: "Flax", src: CFCDN + "Sunset/Flax.jpg"}, {title: "Lace", src: CFCDN + "Sunset/Lace.jpg"}, {title: "Lava", src: CFCDN + "Sunset/Lava.jpg"}, {title: "Mushroom", src: CFCDN + "Sunset/Mushroom.jpg"}, {title: "Natural", src: CFCDN + "Sunset/Natural.jpg"}, {title: "Onyx", src: CFCDN + "Sunset/Onyx.jpg"}, {title: "Parchment", src: CFCDN + "Sunset/Parchment.jpg"}, {title: "Pepper", src: CFCDN + "Sunset/Pepper.jpg"}, {title: "Sahara", src: CFCDN + "Sunset/Sahara.jpg"}, {title: "Seal", src: CFCDN + "Sunset/Seal.jpg"}, {title: "Silver", src: CFCDN + "Sunset/Silver.jpg"}, {title: "Snow", src: CFCDN + "Sunset/Snow.jpg"}, {title: "Stone", src: CFCDN + "Sunset/Stone.jpg"}, {title: "Tuape", src: CFCDN + "Sunset/Tuape.jpg"}, {title: "Vanilla", src: CFCDN + "Sunset/Vanilla.jpg"}, {title: "Warm Grey", src: CFCDN + "Sunset/Warm Grey.jpg"}]
const mandalayBO = [{title: "Abalone", src: CFCDN + "Mandalay/Abalone.jpg"}, {title: "Alabaster", src: CFCDN + "Mandalay/Alabaster.jpg"}, {title: "Alpaca", src: CFCDN + "Mandalay/Alpaca.jpg"}, {title: "Cement", src: CFCDN + "Mandalay/Cement.jpg"}, {title: "Cloud", src: CFCDN + "Mandalay/Cloud.jpg"}, {title: "Donkey", src: CFCDN + "Mandalay/Donkey.jpg"}, {title: "Ivory", src: CFCDN + "Mandalay/Ivory.jpg"}, {title: "Muslin", src: CFCDN + "Mandalay/Muslin.jpg"}]
const Tapestry = [{title: "Buff", src: CFCDN + "Tapestry-BOLF/Buff.jpg"}, {title: "Cloud", src: CFCDN + "Tapestry-BOLF/Cloud.jpg"}, {title: "Concrete", src: CFCDN + "Tapestry-BOLF/Concrete.jpg"}, {title: "Dove", src: CFCDN + "Tapestry-BOLF/Dove.jpg"}, {title: "Gunmetal", src: CFCDN + "Tapestry-BOLF/Gunmetal.jpg"}, {title: "Portland", src: CFCDN + "Tapestry-BOLF/Portland.jpg"}, {title: "Seagull", src: CFCDN + "Tapestry-BOLF/Seagull.jpg"}, {title: "Tuxedo", src: CFCDN + "Tapestry-BOLF/Tuxedo.jpg"}, {title: "White Wash", src: CFCDN + "Tapestry-BOLF/White Wash.jpg"}]

// Lifht Filter Fabrics

const douLF = [{title: "Bright White", src: CFCDN + "Duo-LF/Bright White.jpg"}, {title: "Mid Grey", src: CFCDN + "Duo-LF/Mid Grey.jpg"}, {title: "Warm White", src: CFCDN + "Duo-LF/Warm White.jpg"}]
const chatsworthLF = [{title: "Caviar", src: CFCDN + "Chastworth-LF/Caviar.jpg"}, {title: "Doe", src: CFCDN + "Chastworth-LF/Doe.jpg"}, {title: "Espresso", src: CFCDN + "Chastworth-LF/Espresso.jpg"}, {title: "Glow", src: CFCDN + "Chastworth-LF/Glow.jpg"}, {title: "Halo", src: CFCDN + "Chastworth-LF/Halo.jpg"}, {title: "Icicle", src: CFCDN + "Chastworth-LF/Icicle.jpg"}, {title: "Mirage", src: CFCDN + "Chastworth-LF/Mirage.jpg"}, {title: "Nutmeg", src: CFCDN + "Chastworth-LF/Nutmeg.jpg"}, {title: "Oasis", src: CFCDN + "Chastworth-LF/Oasis.jpg"}, {title: "Oyster", src: CFCDN + "Chastworth-LF/Oyster.jpg"}, {title: "Pearl", src: CFCDN + "Chastworth-LF/Pearl.jpg"}, {title: "Walnut", src: CFCDN + "Chastworth-LF/Walnut.jpg"}]
const levereLF = [{title: "Chalk", src: CFCDN + "lereve-lightfilter/Chalk.jpg"}, {title: "Concrete", src: CFCDN + "lereve-lightfilter/Concrete.jpg"}, {title: "Crystal", src: CFCDN + "lereve-lightfilter/Crystal.jpg"}, {title: "Graphite", src: CFCDN + "lereve-lightfilter/Graphite.jpg"}, {title: "Marble", src: CFCDN + "lereve-lightfilter/Marble.jpg"}, {title: "Mink", src: CFCDN + "lereve-lightfilter/Mink.jpg"}, {title: "Onyx", src: CFCDN + "lereve-lightfilter/Onyx.jpg"}, {title: "Pewter", src: CFCDN + "lereve-lightfilter/Pewter.jpg"}, {title: "Sand", src: CFCDN + "lereve-lightfilter/Sand.jpg"}, {title: "Shell", src: CFCDN + "lereve-lightfilter/Shell.jpg"}]
const linsqueLF = [{title: "Chestnut", src: CFCDN + "Linsque-LF/Chestnut.jpg"}, {title: "Delta", src: CFCDN + "Linsque-LF/Delta.jpg"}, {title: "Granite", src: CFCDN + "Linsque-LF/Granite.jpg"}, {title: "Hazel", src: CFCDN + "Linsque-LF/Hazel.jpg"}, {title: "Levi", src: CFCDN + "Linsque-LF/Levi.jpg"}, {title: "Lily", src: CFCDN + "Linsque-LF/Lily.jpg"}, {title: "Oatcake", src: CFCDN + "Linsque-LF/Oatcake.jpg"}, {title: "Owl", src: CFCDN + "Linsque-LF/Owl.jpg"}, {title: "Stonewash", src: CFCDN + "Linsque-LF/Stonewash.jpg"}, {title: "Trellis", src: CFCDN + "Linsque-LF/Trellis.jpg"}, {title: "Wicker", src: CFCDN + "Linsque-LF/Wicker.jpg"}, {title: "Winter", src: CFCDN + "Linsque-LF/Winter.jpg"}]
const mantraLF = [{title: "Cotton", src: CFCDN + "mantra-lightfilter/Cotton.jpg"}, {title: "Parchment", src: CFCDN + "mantra-lightfilter/Parchment.jpg"}, {title: "Pebble", src: CFCDN + "mantra-lightfilter/Pebble.jpg"}, {title: "Seagrass", src: CFCDN + "mantra-lightfilter/Seagrass.jpg"}, {title: "Seed Pearl", src: CFCDN + "mantra-lightfilter/Seed Pearl.jpg"}, {title: "Sesame", src: CFCDN + "mantra-lightfilter/Sesame.jpg"}, {title: "Shale", src: CFCDN + "mantra-lightfilter/Shale.jpg"}]
const palmBeachLF = [{title: "Angora", src: CFCDN + "Palm-Beach-LF/Angora.jpg"}, {title: "Horizon", src: CFCDN + "Palm-Beach-LF/Horizon.jpg"}, {title: "Ink", src: CFCDN + "Palm-Beach-LF/Ink.jpg"}, {title: "Melody", src: CFCDN + "Palm-Beach-LF/Melody.jpg"}, {title: "Monsoon", src: CFCDN + "Palm-Beach-LF/Monsoon.jpg"}, {title: "Pearl", src: CFCDN + "Palm-Beach-LF/Pearl.jpg"}, {title: "Steel", src: CFCDN + "Palm-Beach-LF/Steel.jpg"}]
const skyeLF = [{title: "Blazer", src: CFCDN + "Skye-LF/Blazer.jpg"}, {title: "Chiffon", src: CFCDN + "Skye-LF/Chiffon.jpg"}, {title: "Chrome", src: CFCDN + "Skye-LF/Chrome.jpg"}, {title: "Earl Grey", src: CFCDN + "Skye-LF/Earl Grey.jpg"}, {title: "Oyster", src: CFCDN + "Skye-LF/Oyster.jpg"}, {title: "Porcelain", src: CFCDN + "Skye-LF/Porcelain.jpg"}, {title: "Raven", src: CFCDN + "Skye-LF/Raven.jpg"}, {title: "Sail", src: CFCDN + "Skye-LF/Sail.jpg"}, {title: "Swan", src: CFCDN + "Skye-LF/Swan.jpg"}]
const aventusSC = [{title: "Charcoal Bronze", src: CFCDN + "Aventus-SC/Charcoal Bronze.jpg"}, {title: "Charcoal Denim", src: CFCDN + "Aventus-SC/Charcoal Denim.jpg"}, {title: "Charcoal Grey", src: CFCDN + "Aventus-SC/Charcoal Grey.jpg"}, {title: "Charcoal", src: CFCDN + "Aventus-SC/Charcoal.jpg"}, {title: "Concrete", src: CFCDN + "Aventus-SC/Concrete.jpg"}, {title: "Domino", src: CFCDN + "Aventus-SC/Domino.jpg"}, {title: "Dune Grey", src: CFCDN + "Aventus-SC/Dune Grey.jpg"}, {title: "Graphite", src: CFCDN + "Aventus-SC/Graphite.jpg"}, {title: "Gull", src: CFCDN + "Aventus-SC/Gull.jpg"}, {title: "Ice", src: CFCDN + "Aventus-SC/Ice.jpg"}, {title: "Pewter", src: CFCDN + "Aventus-SC/Pewter.jpg"}, {title: "Platinum", src: CFCDN + "Aventus-SC/Platinum.jpg"}, {title: "White Grey", src: CFCDN + "Aventus-SC/White Grey.jpg"}, {title: "White Linen", src: CFCDN + "Aventus-SC/White Linen.jpg"}, {title: "White Stone", src: CFCDN + "Aventus-SC/White Stone.jpg"}, {title: "White", src: CFCDN + "Aventus-SC/White.jpg"}, {title: "Wren", src: CFCDN + "Aventus-SC/Wren.jpg"}]
export interface Fabric{
    title:string;
    src:string;
}
export interface Fabrics {
    title: string;
    id:number;
    desciption:string;
    colours:Fabric[]
    src:string;
}
export const fabricBrandBlockOut89 = [
    {
        title: 'Vibe Blockout ★',
        id: 1,
        desciption : "Featured PVC free acrylic coating has anti-fade, 100% blackout, easy clean and antifungal properties.",
        colours: VibeBlockout,
        src: CFCDN+"vibe-block-out/Vibe_HERO.jpg",
    },
    {
        title: 'Skye Blockout ★',
        id: 9,
        desciption : "Skye has a subtle texture enhanced with cationic yarn and a modern colour range. ",
        colours: skyBlockout,
        src: CFCDN + "Skye-LF/Skye_HERO_LF.jpg",
    },
    {
        title: 'Karma Blockout',
        id: 4,
        desciption : "Karma fabric is renowned for its sleek, modern appearance.",
        colours: KamarBlockOut,
        src: CFCDN + "kamar-block-out/Karma_HERO_BO.jpg",
    },
    
    {
        title: 'Dawn Blockout',
        id: 10,
        desciption : "",
        colours: dawnBO,
        src: CFCDN + "Dawn/DAWN-HERO-2.jpg",
    },
    {
        title: 'Sunset Blockout',
        id: 11,
        desciption : "",
        colours: sunsetBO,
        src: CFCDN + "Sunset/Sunset-HERO-2.jpeg",
    }
    ,
    {
        title: 'Mandalay Blockout',
        id: 12,
        desciption : "",
        colours: mandalayBO,
        src: CFCDN + "Mandalay/Abalone.jpg",
    }
    ,
    {
        title: 'Tapestry Blockout',
        id: 13,
        desciption : "",
        colours: Tapestry,
        src: CFCDN + "Tapestry-BOLF/Tapestry-HERO.jpg",
    }
    
    
]

export const fabricBrandBlockOut100 = [
    {
        title: 'Vibe Blockout ★',
        id: 1,
        desciption : "Featured PVC free acrylic coating has anti-fade, 100% blackout, easy clean and antifungal properties.",
        colours: VibeBlockout,
        src: CFCDN+"vibe-block-out/Vibe_HERO.jpg",
    },
    
    {
        title: 'Karma Blockout',
        id: 4,
        desciption : "Karma fabric is renowned for its sleek, modern appearance.",
        colours: KamarBlockOut,
        src: CFCDN + "kamar-block-out/Karma_HERO_BO.jpg",
    },
    
    {
        title: 'Dawn Blockout',
        id: 10,
        desciption : "",
        colours: dawnBO,
        src: CFCDN + "Dawn/DAWN-HERO-2.jpg",
    },
    {
        title: 'Sunset Blockout',
        id: 11,
        desciption : "",
        colours: sunsetBO,
        src: CFCDN + "Sunset/Sunset-HERO-2.jpeg",
    }
    ,
    {
        title: 'Mandalay Blockout',
        id: 12,
        desciption : "",
        colours: mandalayBO,
        src: CFCDN + "Mandalay/Abalone.jpg",
    }
    ,
    {
        title: 'Tapestry Blockout',
        id: 13,
        desciption : "",
        colours: Tapestry,
        src: CFCDN + "Tapestry-BOLF/Tapestry-HERO.jpg",
    }
    
]

export const fabricBrandBlockOut127 = [
    {
        title: 'Vibe Blockout ★',
        id: 1,
        desciption : "Featured PVC free acrylic coating has anti-fade, 100% blackout, easy clean and antifungal properties.",
        colours: VibeBlockout,
        src: CFCDN+"vibe-block-out/Vibe_HERO.jpg",
    },
    {
        title: 'Skye Blockout ★',
        id: 9,
        desciption : "Skye has a subtle texture enhanced with cationic yarn and a modern colour range. ",
        colours: skyBlockout,
        src: CFCDN + "Skye-LF/Skye_HERO_LF.jpg",
    },
    
    {
        title: 'Karma Blockout',
        id: 4,
        desciption : "Karma fabric is renowned for its sleek, modern appearance.",
        colours: KamarBlockOut,
        src: CFCDN + "kamar-block-out/Karma_HERO_BO.jpg",
    },
    {
        title: 'Dawn Blockout',
        id: 10,
        desciption : "",
        colours: dawnBO,
        src: CFCDN + "Dawn/DAWN-HERO-2.jpg",
    },
    {
        title: 'Sunset Blockout',
        id: 11,
        desciption : "",
        colours: sunsetBO,
        src: CFCDN + "Sunset/Sunset-HERO-2.jpeg",
    }
    ,
    {
        title: 'Mandalay Blockout',
        id: 12,
        desciption : "",
        colours: mandalayBO,
        src: CFCDN + "Mandalay/Abalone.jpg",
    }
    ,
    {
        title: 'Tapestry Blockout',
        id: 13,
        desciption : "",
        colours: Tapestry,
        src: CFCDN + "Tapestry-BOLF/Tapestry-HERO.jpg",
    }
    
]


export const fabricType = [
    {title:'89mm Fabric',src:CFCDN+'vertical-blinds/89mm.png',fabrics : fabricBrandBlockOut89, desc: [ 'Sleek, modern, and delicate.','Offers precise light control.','Ideal for smaller windows or tighter spaces.']},
    {title:'100mm Fabric',src:CFCDN+'vertical-blinds/100mm.png',fabrics : fabricBrandBlockOut100, desc: ['Balanced and versatile look.','Provides good light control.','Suitable for a variety of window sizes.']},
    {title:'127mm Fabric',src:CFCDN+'vertical-blinds/127mm.png',fabrics : fabricBrandBlockOut127,desc: ['Bold and substantial visual statement.','Allows more light when slats are open.','Easier to clean and maintain due to larger slats.'] },
]

export const ChainColor = [
    {title: "Stainless Steel ★",src:CFCDN+'roller-blind/RollerBlindChain/stainless-steel.png'},
    {title: "White",src:CFCDN+'roller-blind/RollerBlindChain/white.png'},
    {title: "Ivory",src:CFCDN+'roller-blind/RollerBlindChain/ivory.png'},
    {title: "Grey",src:CFCDN+'roller-blind/RollerBlindChain/grey.png'},
    {title: "Driftwood",src:CFCDN+'roller-blind/RollerBlindChain/driftwood.png'},
    {title: "Black",src:CFCDN+'roller-blind/RollerBlindChain/black.png'}
]
export const WandColor = [
    {title: "White",src:CFCDN+'vertical-blinds/wand/white.png'},
    {title: "Ivory",src:CFCDN+'vertical-blinds/wand/ivory.png'},
    {title: "Grey",src:CFCDN+'vertical-blinds/wand/grey.png'},
    {title: "Driftwood",src:CFCDN+'vertical-blinds/wand/driftwood.png'},
    {title: "Black",src:CFCDN+'vertical-blinds/wand/black.png'}
]
export const bracket = [
    {title: "Uniline Track",src:CFCDN+'roller-blind/bracket/bracket.png'},
    {title: "Extension Bracket",src:CFCDN+'roller-blind/bracket/extension-bracket.png'},
    
]

export interface  Color {
    id: number,
    title: string,
    color: string
}
export const bottomBar = [
    {
        title: "Chainless",
        src:CFCDN+'vertical-blinds/chainless.png',
    },  
    {   
        title: "Chain linked",
        src:CFCDN+'vertical-blinds/linked.png',
    },  
    {   
        title: "Sew-in weights",
        src:CFCDN+'vertical-blinds/sew-in.png',
    }
]

    export const bracketColors= [
   
    {id: 1, title: "White", color:"#ffffff"},
    {id: 2, title: "Cream", color:"#e3d1b0"}, 
    {id: 3, title: "Grey", color:"#b0afa7"},
    {id: 4, title: "Black", color:"#121212"},  ] 


  
    export const controlType = [
        {title: "Cord",src:CFCDN+'vertical-blinds/chain-control.png'},
        {title: "Wand",src:CFCDN+'vertical-blinds/wand-control.png'}
    ]
   
    